import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69215c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = {
  key: 0,
  class: "custom-card-title title-card"
}
const _hoisted_3 = {
  key: 1,
  class: "notification is-danger is-light"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 2,
  class: "accounts"
}
const _hoisted_6 = { class: "row-user" }
const _hoisted_7 = { class: "user-label" }
const _hoisted_8 = { class: "row-actions" }
const _hoisted_9 = { class: "buttons is-right" }
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "button-label" }
const _hoisted_13 = ["id", "onClick"]
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = { class: "button-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pendingUserAccounts.length !== 0)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$gettext("Account creations waiting for approval")), 1))
      : _createCommentVNode("", true),
    (_ctx.hasLoadingError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$gettext(
            "An unexpected issue occurred while loading the " +
              "pending account list. Sorry for the inconvenience."
          )), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$gettext(
            "You can try to refresh the page, if the issue " +
              "persists, you may want to contact your " +
              "administrator"
          )), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingUserAccounts, (account) => {
              return (_openBlock(), _createElementBlock("div", {
                key: account.id,
                class: "mb-2 account-row shadow-bottom"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(account.name) + " " + _toDisplayString(account.markBackend ? `(via ${account.backendId})` : ""), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "button is-primary custom-button custom-inverted is-small discard-account icon-btn",
                      id: `discard-${account.id}`,
                      onClick: ($event: any) => (_ctx.discardUserAccount(account))
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_fa_icon, {
                          class: "fa-thick",
                          icon: "xmark"
                        })
                      ]),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$gettext("Discard")), 1)
                    ], 8, _hoisted_10),
                    _createElementVNode("a", {
                      class: "button is-primary custom-button custom-inverted is-small validate-account icon-btn",
                      id: `validate-${account.id}`,
                      onClick: ($event: any) => (_ctx.validateUserAccount(account))
                    }, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_fa_icon, {
                          class: "fa-thick",
                          icon: "check"
                        })
                      ]),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$gettext("Approve")), 1)
                    ], 8, _hoisted_13)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
  ]))
}